export const SHIFT_SELECTION_STATUS = {
    CONFLICT: 'CONFLICT',
    SELECTED: 'SELECTED',
    UNSELECTED: 'UNSELECTED'
}

export const SHIFT_PLAN_STATUS_TYPES = {
    GENERATED: 'GENERATED',
    SELECTED: 'SELECTED'
}

export const REPEAT_FREQUENCY = {
    WEEKDAYS: 'Weekdays',
    WEEKLY: 'Weekly',
    DAILY: 'Daily'
}

export const ROUNDING_MINUTES_FOR_SHIFT_TIME = 5;
export const ROUNDING_MINUTES_FOR_SHIFT_END_TIME = 15;
export const SECONDS_INTO_MINUTES = 60;
export const MOMENT_UNIT_MINUTES = 'minutes';
export const WARNING_UPDATE_DELAY_IN_MILISECONDS = 500;
export const MAXIMUM_NUMBER_OF_MONTHS_ALLOWED_FOR_CREATING_REPEATING_PLANS = 3;
export const SHIFT_PLAN_TIMEBLOCK_WIDTH_VW = 6.5;
export const SHIFT_PLAN_TIMEBLOCK_MIN_WIDTH_REM = 6;
